import script from "./DoctorPayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorPayout.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorPayout.vue?vue&type=style&index=0&id=ceb3aa8a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceb3aa8a"]])

export default __exports__